import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import SmallModal from '../../../components/Modals/SmallModal'
import { DetailRow } from '../../../components/Cards/DetailsBox'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

const SMSPopup = ({ selectedSMS, setSelectedSMS }) => {
  return (
    <SmallModal
      open={selectedSMS}
      onClose={() => setSelectedSMS(null)}
      style={{ width: '500px', maxWidth: '90vw' }}
    >
      <Stack gap={0.5}>
        <DetailRow
          label="Date"
          value={moment(selectedSMS?.createdAt).format('Do MMM YYYY HH:mm')}
          fullWidthLabel
        />
        <DetailRow
          label="To"
          value={
            selectedSMS?.toUser?.firstName + ' ' + selectedSMS?.toUser?.lastName
          }
          fullWidthLabel
        />
        {selectedSMS?.sentBy && (
          <DetailRow
            label="From"
            value={
              selectedSMS?.sentBy?.firstName +
              ' ' +
              selectedSMS?.sentBy?.lastName
            }
            fullWidthLabel
          />
        )}
        <DetailRow
          label="Number"
          value={selectedSMS?.toNumber}
          fullWidthLabel
        />
        <DetailRow
          label="Credits User"
          value={selectedSMS?.creditsUsed}
          fullWidthLabel
        />
        <DetailRow
          label="Message"
          value={selectedSMS?.message}
          fullWidthLabel
        />
        <Button
          onClick={() => setSelectedSMS(null)}
          color="error"
          fullWidth
          variant="outlined"
          sx={{ marginTop: 2 }}
        >
          Close
        </Button>
      </Stack>
    </SmallModal>
  )
}

SMSPopup.propTypes = {
  selectedSMS: PropTypes.object.isRequired,
  setSelectedSMS: PropTypes.func.isRequired,
}

export default SMSPopup
